import Vue from 'vue'
import Vuex from 'vuex'
import home from './modules/home'
import getters from './getters'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    home: home,
  },
  getters
})

export default store

// this.$store.dispatch('GetLang', this.langVal)
// this.$store.dispatch('LogOut').then(() => {
//   location.href = '/index';
// })



// WEBPACK FOOTER //
// ./src/store/index.js